import axios from 'axios';
import Env from '../Env';
import { authProvider } from '../authProvider';

const b2cOptions = Env.getB2COptions();
async function getAccessToken() {
  const accounts = authProvider.getAllAccounts();

  if (accounts.length === 0) {
    await authProvider.loginRedirect();
  }

  if (accounts.length > 0) {
    const request = {
      scopes: [b2cOptions.appId],
      account: accounts[0],
      forceRefresh: false
    };
    const accessToken = await authProvider.acquireTokenSilent(request).then((response) => {
      return response.accessToken;
    }).catch(error => {
      // Do not fallback to interaction when running outside the context of MsalProvider. Interaction should always be done inside context.
      console.log(error);
      authProvider.acquireTokenRedirect(request);
    });
    return accessToken;
  }
  return null;
}

export const fetchClient = async ({ url, queryParams, headers, method, body, apiServer = Env.getApiBaseUrl(), responseType = null }) => {
  await authProvider.handleRedirectPromise();

  const fullyQualifiedUrl = `${apiServer}${url}`;
  const token = await getAccessToken();
  const result = await axios(fullyQualifiedUrl, {
    method,
    params: queryParams,
    headers: {
      'Accept': 'application/json',
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Pragma': 'no-cache',
      ...headers
    },
    data: body,
    responseType: responseType
  });
  return result.data;
};
